import SetLanguage from './SetLanguage';
export default SetLanguage;